module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-sm-12"
  }, [_c('div', {
    staticClass: "step-form__main pt-3"
  }, [(this.$route.query.type == 'equipment') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Equipment information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Vendor name",
      "prop": "vendorName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Vendor name"
    },
    model: {
      value: (_vm.uploadForm.vendorName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorName", $$v)
      },
      expression: "uploadForm.vendorName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone",
      "prop": "vendorPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "",
      "maxlength": 10
    },
    model: {
      value: (_vm.uploadForm.vendorPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorPhone", $$v)
      },
      expression: "uploadForm.vendorPhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vendor address",
      "prop": "vendorAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40
    },
    model: {
      value: (_vm.uploadForm.vendorAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorAddress", $$v)
      },
      expression: "uploadForm.vendorAddress"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "vendorCity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30
    },
    model: {
      value: (_vm.uploadForm.vendorCity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorCity", $$v)
      },
      expression: "uploadForm.vendorCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "State",
      "prop": "vendorState"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.uploadForm.vendorState),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorState", $$v)
      },
      expression: "uploadForm.vendorState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip code",
      "prop": "vendorZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "5-digit postal code",
      "maxlength": 5
    },
    model: {
      value: (_vm.uploadForm.vendorZipCode),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "vendorZipCode", $$v)
      },
      expression: "uploadForm.vendorZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Equipment amount",
      "prop": "equipmentAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.equipmentAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentAmount", $$v)
      },
      expression: "uploadForm.equipmentAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment status",
      "prop": "equipmentStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Equipment status"
    },
    model: {
      value: (_vm.uploadForm.equipmentStatus),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentStatus", $$v)
      },
      expression: "uploadForm.equipmentStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Down Payment?",
      "prop": "wantDownPayment"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Do you want to pay a down payment?"
    },
    model: {
      value: (_vm.uploadForm.wantDownPayment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "wantDownPayment", $$v)
      },
      expression: "uploadForm.wantDownPayment"
    }
  }, _vm._l((_vm.downPaymentOrNot), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Reason for equipment purchase",
      "prop": "reasonForEquipment"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Reason for equipment purchase"
    },
    model: {
      value: (_vm.uploadForm.reasonForEquipment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "reasonForEquipment", $$v)
      },
      expression: "uploadForm.reasonForEquipment"
    }
  }, _vm._l((_vm.reasonsForEquipment), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Equipment type",
      "prop": "equipmentType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "What kind of equipment are you financing?"
    },
    model: {
      value: (_vm.uploadForm.equipmentType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentType", $$v)
      },
      expression: "uploadForm.equipmentType"
    }
  }, _vm._l((_vm.equipmentTypes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "margin-bottom-0",
    attrs: {
      "label": "Equipment description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.uploadForm.equipmentDesc),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "equipmentDesc", $$v)
      },
      expression: "uploadForm.equipmentDesc"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (this.$route.query.type == 'property') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Property information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Property address",
      "prop": "propertyAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40
    },
    model: {
      value: (_vm.uploadForm.propertyAddress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyAddress", $$v)
      },
      expression: "uploadForm.propertyAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Address Line 2",
      "prop": "propertyAddress2"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 40
    },
    model: {
      value: (_vm.uploadForm.propertyAddress2),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyAddress2", $$v)
      },
      expression: "uploadForm.propertyAddress2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City",
      "prop": "propertyCity"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 30
    },
    model: {
      value: (_vm.uploadForm.propertyCity),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyCity", $$v)
      },
      expression: "uploadForm.propertyCity"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "State",
      "prop": "propertyState"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select state"
    },
    model: {
      value: (_vm.uploadForm.propertyState),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyState", $$v)
      },
      expression: "uploadForm.propertyState"
    }
  }, _vm._l((_vm.stateS), function(item) {
    return _c('el-option', {
      key: item.text,
      attrs: {
        "label": item.text,
        "value": item.text
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Zip code",
      "prop": "propertyZipCode"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "placeholder": "5-digit postal code",
      "maxlength": 5
    },
    model: {
      value: (_vm.uploadForm.propertyZipCode),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyZipCode", $$v)
      },
      expression: "uploadForm.propertyZipCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    staticClass: "step-form__form-item--with-unit",
    attrs: {
      "label": "Property type",
      "prop": "propertyType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Property type"
    },
    model: {
      value: (_vm.uploadForm.propertyType),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyType", $$v)
      },
      expression: "uploadForm.propertyType"
    }
  }, _vm._l((_vm.property_type), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Purchase date",
      "prop": "propertyPurchaseDate"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 10,
      "placeholder": "mm/dd/yyyy"
    },
    model: {
      value: (_vm.uploadForm.propertyPurchaseDate),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyPurchaseDate", $$v)
      },
      expression: "uploadForm.propertyPurchaseDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Purchase price",
      "prop": "propertyPurchasePrice"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyPurchasePrice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyPurchasePrice", $$v)
      },
      expression: "uploadForm.propertyPurchasePrice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Estimated current market value",
      "prop": "propertyEstimatedValue"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyEstimatedValue),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyEstimatedValue", $$v)
      },
      expression: "uploadForm.propertyEstimatedValue"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mortgage balance",
      "prop": "propertyMortgageBalance"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyMortgageBalance),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyMortgageBalance", $$v)
      },
      expression: "uploadForm.propertyMortgageBalance"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly payment",
      "prop": "propertyMonthlyPayment"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyMonthlyPayment),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyMonthlyPayment", $$v)
      },
      expression: "uploadForm.propertyMonthlyPayment"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Annual cost of taxes, insurance, etc.",
      "prop": "propertyAnnualCost"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyAnnualCost),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyAnnualCost", $$v)
      },
      expression: "uploadForm.propertyAnnualCost"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Monthly income",
      "prop": "monthlyIncome"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.monthlyIncome),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "monthlyIncome", $$v)
      },
      expression: "uploadForm.monthlyIncome"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Building square footage",
      "prop": "propertyBuildingSqft"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyBuildingSqft),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyBuildingSqft", $$v)
      },
      expression: "uploadForm.propertyBuildingSqft"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Land area (acres)",
      "prop": "propertyLandArea"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.propertyLandArea),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "propertyLandArea", $$v)
      },
      expression: "uploadForm.propertyLandArea"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), (this.$route.query.type == 'billing') ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "uploadForm",
    staticClass: "step-form__form",
    attrs: {
      "model": _vm.uploadForm
    }
  }, [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Previous Business Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24,
      "lg": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Previous business names used within the past five (5) years",
      "prop": "previousBusinessNames"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.previousBusinessNames),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "previousBusinessNames", $$v)
      },
      expression: "uploadForm.previousBusinessNames"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any subsidiaries or affiliates of business?",
      "prop": "anySubsidiariesOrAffiliates"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anySubsidiariesOrAffiliates),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anySubsidiariesOrAffiliates", $$v)
      },
      expression: "uploadForm.anySubsidiariesOrAffiliates"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Explain subsidiaries or affiliates of business if any",
      "prop": "subsidiariesOrAffiliatesExplanation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.subsidiariesOrAffiliatesExplanation),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "subsidiariesOrAffiliatesExplanation", $$v)
      },
      expression: "uploadForm.subsidiariesOrAffiliatesExplanation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Has there been any change of ownership in the past twelve (12) months?",
      "prop": "anyChangeOfOwnership"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyChangeOfOwnership),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyChangeOfOwnership", $$v)
      },
      expression: "uploadForm.anyChangeOfOwnership"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Explain change of ownership if any",
      "prop": "changeOfOwnershipExplanation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.changeOfOwnershipExplanation),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "changeOfOwnershipExplanation", $$v)
      },
      expression: "uploadForm.changeOfOwnershipExplanation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Tax Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "FEDERAL TAX ID",
      "prop": "federalTaxID"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.tin),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "tin", $$v)
      },
      expression: "uploadForm.tin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any Federal or State taxes past due, including but not limited to withholding taxes?",
      "prop": "taxesPastDue"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifCurrentTaxesPaid),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifCurrentTaxesPaid", $$v)
      },
      expression: "uploadForm.ifCurrentTaxesPaid"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, has any lien been filed?",
      "prop": "taxesPastDueLienFiled"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLiensPlaced),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLiensPlaced", $$v)
      },
      expression: "uploadForm.anyLiensPlaced"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any levies filed?",
      "prop": "anyTaxesPastDueLeviesFiled"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyTaxesPastDueLeviesFiled),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyTaxesPastDueLeviesFiled", $$v)
      },
      expression: "uploadForm.anyTaxesPastDueLeviesFiled"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, please list lien or levy details(TYPE; QUARTER/YEAR; AMOUNT: $)",
      "prop": "taxesPastDueFileDetail"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.taxesPastDueFileDetail),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "taxesPastDueFileDetail", $$v)
      },
      expression: "uploadForm.taxesPastDueFileDetail"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any payment plans in place?",
      "prop": "taxPaymentPlansInPlace"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyPaymentPlan),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyPaymentPlan", $$v)
      },
      expression: "uploadForm.anyPaymentPlan"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Legal & Financial")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any lawsuits pending?",
      "prop": "lawsuitsPending"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyLawsuit),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyLawsuit", $$v)
      },
      expression: "uploadForm.anyLawsuit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Explain lawsuits pending if any",
      "prop": "lawsuitsPendingExplanation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.lawsuitsPendingExplanation),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "lawsuitsPendingExplanation", $$v)
      },
      expression: "uploadForm.lawsuitsPendingExplanation"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Any judgements?",
      "prop": "anyJudgements"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyJudgements),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyJudgements", $$v)
      },
      expression: "uploadForm.anyJudgements"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Explain judgements if any",
      "prop": "judgementsExplanation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.judgementsExplanation),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "judgementsExplanation", $$v)
      },
      expression: "uploadForm.judgementsExplanation"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any past bankruptcies?",
      "prop": "anyPastBankruptcies"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyPastBankruptcies),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyPastBankruptcies", $$v)
      },
      expression: "uploadForm.anyPastBankruptcies"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If any past bankruptcies, when?",
      "prop": "pastBankruptciesWhen"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.pastBankruptciesWhen),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "pastBankruptciesWhen", $$v)
      },
      expression: "uploadForm.pastBankruptciesWhen"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bank Name",
      "prop": "bankName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.bankName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "bankName", $$v)
      },
      expression: "uploadForm.bankName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account Officer",
      "prop": "bankAccountOfficerName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.bankAccountOfficerName),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "bankAccountOfficerName", $$v)
      },
      expression: "uploadForm.bankAccountOfficerName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Officer Phone",
      "prop": "bankPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.bankPhone),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "bankPhone", $$v)
      },
      expression: "uploadForm.bankPhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Account No.",
      "prop": "bankAccountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.bankAccountNumber),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "bankAccountNumber", $$v)
      },
      expression: "uploadForm.bankAccountNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "City & State",
      "prop": "bankCityAndState"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.bankCityAndState),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "bankCityAndState", $$v)
      },
      expression: "uploadForm.bankCityAndState"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "padding-left": "5px"
    }
  }, [_vm._v("Accounts Receivable Information")])]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Receivable amount open as of today",
      "prop": "receivableAmounts"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.receivableAmounts),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "receivableAmounts", $$v)
      },
      expression: "uploadForm.receivableAmounts"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "No. of Accounts",
      "prop": "numberOfAccounts"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.numberOfAccounts),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "numberOfAccounts", $$v)
      },
      expression: "uploadForm.numberOfAccounts"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Terms of Sale",
      "prop": "termsOfSale"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.termsOfSale),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "termsOfSale", $$v)
      },
      expression: "uploadForm.termsOfSale"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aging Current",
      "prop": "agingCurrent"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.agingCurrent),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "agingCurrent", $$v)
      },
      expression: "uploadForm.agingCurrent"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aging 31-60",
      "prop": "aging31_60"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.aging31_60),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "aging31_60", $$v)
      },
      expression: "uploadForm.aging31_60"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aging 61-90",
      "prop": "aging61_90"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.aging61_90),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "aging61_90", $$v)
      },
      expression: "uploadForm.aging61_90"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 5,
      "lg": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aging 91-120",
      "prop": "aging91_120"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.aging91_120),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "aging91_120", $$v)
      },
      expression: "uploadForm.aging91_120"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Aging Over 120",
      "prop": "agingOver120"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.agingOver120),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "agingOver120", $$v)
      },
      expression: "uploadForm.agingOver120"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total sales last 30 days",
      "prop": "totalSales30Days"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.totalSales30Days),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "totalSales30Days", $$v)
      },
      expression: "uploadForm.totalSales30Days"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total sales last 12 months",
      "prop": "totalSales12Months"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.totalSales12Months),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "totalSales12Months", $$v)
      },
      expression: "uploadForm.totalSales12Months"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Amount you intend to factor on a monthly basis?",
      "prop": "amountIntendToFactorMonthly"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.desiredFactoringAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "desiredFactoringAmount", $$v)
      },
      expression: "uploadForm.desiredFactoringAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Where are remittances mailed?",
      "prop": "whereRemittancesMailed"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.whereRemittancesMailed),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "whereRemittancesMailed", $$v)
      },
      expression: "uploadForm.whereRemittancesMailed"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Have receivables been financed or factored before?",
      "prop": "ifReceivablesFactoredBefore"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifReceivablesFactoredBefore),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifReceivablesFactoredBefore", $$v)
      },
      expression: "uploadForm.ifReceivablesFactoredBefore"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are receivables currently being financed or factored?",
      "prop": "ifReceivablesFactoredCurrently"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifReceivablesFactoredCurrently),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifReceivablesFactoredCurrently", $$v)
      },
      expression: "uploadForm.ifReceivablesFactoredCurrently"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Amount of credit losses last three (3) years",
      "prop": "creditLossesLast3Years"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.creditLossesLast3Years),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "creditLossesLast3Years", $$v)
      },
      expression: "uploadForm.creditLossesLast3Years"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "What is your average monthly billing?",
      "prop": "averageMonthlyBilling"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageMonthlyBilling),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageMonthlyBilling", $$v)
      },
      expression: "uploadForm.averageMonthlyBilling"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "What is your average invoice amount?",
      "prop": "averageInvoiceAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.averageInvoiceSize),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "averageInvoiceSize", $$v)
      },
      expression: "uploadForm.averageInvoiceSize"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "What is your largest invoice amount?",
      "prop": "largestInvoiceAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.largestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "largestInvoice", $$v)
      },
      expression: "uploadForm.largestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "What is your smallest invoice amount?",
      "prop": "smallestInvoiceAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.smallestInvoice),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "smallestInvoice", $$v)
      },
      expression: "uploadForm.smallestInvoice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Are any of your receivables Progress Billing?",
      "prop": "anyReceivablesProgressBilling"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyBillInProgress),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyBillInProgress", $$v)
      },
      expression: "uploadForm.anyBillInProgress"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have guaranteed sales?",
      "prop": "haveGuaranteedSales"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anySalesBillHold),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anySalesBillHold", $$v)
      },
      expression: "uploadForm.anySalesBillHold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any active UCC Filings or are your receivables pledged as collateral?",
      "prop": "anyActiveUCCFilings"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.ifReceivablesAsCollateral),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "ifReceivablesAsCollateral", $$v)
      },
      expression: "uploadForm.ifReceivablesAsCollateral"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, with whom?",
      "prop": "activeUCCFilingsWithWhom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.activeUCCFilingsWithWhom),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "activeUCCFilingsWithWhom", $$v)
      },
      expression: "uploadForm.activeUCCFilingsWithWhom"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any outstanding business loans?",
      "prop": "anyOutstandingBusinessLoans"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyOutstandingLoans),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyOutstandingLoans", $$v)
      },
      expression: "uploadForm.anyOutstandingLoans"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, with whom?",
      "prop": "outstandingBusinessLoanWithWhom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.nameOfFinancialInstitution),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "nameOfFinancialInstitution", $$v)
      },
      expression: "uploadForm.nameOfFinancialInstitution"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Loan amount",
      "prop": "outstandingBusinessLoanAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "onkeypress": "return event.keyCode>=48&&event.keyCode<=57",
      "maxlength": 8,
      "min": 0
    },
    model: {
      value: (_vm.uploadForm.outstandingBusinessLoanAmount),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "outstandingBusinessLoanAmount", $$v)
      },
      expression: "uploadForm.outstandingBusinessLoanAmount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("$")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 6,
      "lg": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Term",
      "prop": "outstandingBusinessLoanTerm"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.outstandingBusinessLoanTerm),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "outstandingBusinessLoanTerm", $$v)
      },
      expression: "uploadForm.outstandingBusinessLoanTerm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Do you have any other company assets pledged as collateral (inventory, buildings)?",
      "prop": "anyCompanyAssetsPledgedAsCollateral"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.uploadForm.anyCompanyAssetsPledgedAsCollateral),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "anyCompanyAssetsPledgedAsCollateral", $$v)
      },
      expression: "uploadForm.anyCompanyAssetsPledgedAsCollateral"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "Yes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "No"
    }
  }, [_vm._v("No")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12,
      "lg": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "If yes, with whom?",
      "prop": "companyAssetsPledgedAsCollateralWithWhom"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.uploadForm.companyAssetsPledgedAsCollateralWithWhom),
      callback: function($$v) {
        _vm.$set(_vm.uploadForm, "companyAssetsPledgedAsCollateralWithWhom", $$v)
      },
      expression: "uploadForm.companyAssetsPledgedAsCollateralWithWhom"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (this.$route.query.type == 'paycheck') ? _c('div', [_c('el-row', [_c('h3', {
    staticStyle: {
      "text-align": "left",
      "background": "#006499",
      "color": "white",
      "margin-left": "10%",
      "width": "80%",
      "padding-left": "5px"
    }
  }, [_vm._v("PPP REQUIRED DOCUMENTS")])]), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            1. PPP Borrower Application Form (revised 1.8.2021)-508")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess8,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded8"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            2. Driver’s License / Photo ID")]), _vm._v(" "), (!_vm.dialogVisible) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess9,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded9"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            3. Voided Check")]), _vm._v(" "), (!_vm.dialogVisible3) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess10,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded10"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            4. Bank Statements")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Please provide a bank statement that covers 2/15/2020 as proof that the Applicant was in business as of 2/15/2020. If available, bank statements that are downloaded from your bank’s website will work better than scanned versions.")]), _vm._v(" "), (!_vm.dialogVisible4) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess11,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded11"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            5. Form 1120 or 1120-S")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("To substantiate health insurance (line 24 of 1120 or line 18 of 1120-S) or retirement benefits (line 23 of 1120 or line 17 of 1120-S) to employees.")]), _vm._v(" "), (!_vm.dialogVisible5) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess12,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded12"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "10px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            6. Proof of Payroll Form 940")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    }
  }, [_vm._v("*Applicable only if you have employees*")]), _vm._v(" "), (!_vm.dialogVisible6) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess13,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded13"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "step-form__title",
    staticStyle: {
      "padding-bottom": "38px",
      "color": "#E06D21",
      "font-family": "'Open Sans', sans-serif",
      "font-weight": "700",
      "font-size": "24px",
      "line-height": "24px",
      "text-align": "center"
    }
  }, [_vm._v("\n            7. Form 1040 Schedule C")]), _vm._v(" "), (!_vm.dialogVisible7) ? _c('div', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": "/mingdao/mobile/crmCustomerAttachInfoController/mgxySaveFile.ht",
      "data": {
        tokenId: this.userInfo.token
      },
      "accept": "*.*",
      "show-file-list": false,
      "on-success": _vm.handleAvatarSuccess14,
      "before-upload": _vm.beforeAvatarUpload,
      "on-progress": _vm.openFullScreen
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Choose File")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "step-form__title",
    attrs: {
      "id": "uploaded14"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("submit")])], 1), _vm._v(" "), _c('br')])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "../../../static/PPP Borrower Application Form (revised 1.8.2021)-508.pdf",
      "target": "blank"
    }
  }, [_vm._v("Click here to download 【PPP Borrower Application Form (revised 1.8.2021)-508】")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5568d280"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/UpdateBilling.vue
// module id = 1985
// module chunks = 5